var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01953 6.40456L8.67107 1.33789L16.3226 6.40456",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5937 9.60449V15.4712C14.5946 15.5415 14.5825 15.6113 14.558 15.6764C14.5335 15.7416 14.4972 15.8008 14.4511 15.8505C14.4051 15.9002 14.3503 15.9395 14.29 15.9659C14.2297 15.9924 14.1651 16.0055 14.1 16.0045H3.23978C3.1747 16.0055 3.1101 15.9924 3.04979 15.9659C2.98949 15.9395 2.9347 15.9002 2.88867 15.8505C2.84265 15.8008 2.80633 15.7416 2.78185 15.6764C2.75736 15.6113 2.74523 15.5415 2.74614 15.4712V9.60449",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.777f465c2a0ee8692fa351bcc65a0268.svg";
export { ForwardRef as ReactComponent };